module.exports = __webpack_public_path__ + "img/hr-brown-asterisk-12.a0d7efe6.png";